import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import SidebarObject from "../../../Component/SidebarObject";
import ObjectGallery from "./ObjectGallery";
import { modquizPaths } from "../../../index";

import "./Style.css";

const NewCardButton = ({ show, hashKey }: { show: boolean; hashKey: string }) => {
    if (!show) return null;
    return (
        <Link to={modquizPaths.newQuizObject(hashKey)}>
            <Button variant="contained" color="primary">New Card</Button>
        </Link>
    );
};

const SubjectDetailComponent = ({
    isLoggedIn,
    subject,
    removeSubjectObject,
    location,
}: any) => (
    <Grid container direction="row" className="SubjectDetail">
        <Grid item xs={"auto"} sm={3} md={2}>
            <SidebarObject
                location={location}
                subjectHashKey={subject.hash_key}
                hasCreateAccess={isLoggedIn}
                subject={subject}
                subject_user={subject.user}
                subject_slug={subject.slug}
            />
        </Grid>
        <Grid item xs={"auto"} sm={1} md={1}></Grid>
        <Grid item xs={12} sm={6} md={8}>
            <Grid justifyContent="space-between" container>
                <Grid item>
                    <h3>Cards</h3>
                </Grid>
                <Grid item>
                    <NewCardButton show={subject.canEdit} hashKey={subject.hash_key} />
                </Grid>
            </Grid>
            <ObjectGallery
                subject_slug={subject.hash_key}
                quiz_objects={subject.objects}
                openEditObjectModal={() => {}}
                removeSubjectObject={removeSubjectObject}
                emptyComponent={
                    <div>
                        <h2>There are no objects in this subject.</h2>
                        <br />
                        <NewCardButton show={!!isLoggedIn} hashKey={subject.hash_key} />
                    </div>
                }
            />
        </Grid>
    </Grid>
);

export { SubjectDetailComponent };
